import { appearFromLeft } from "../../../components/AnimatedFormContainer/styles";
import styled, { css } from "styled-components";

export const Container = styled.div`
  margin: 24px auto;
  margin-top: calc(72px + 24px);
  max-width: calc(1260px + 48px);
  padding: 0 24px;
  animation: ${appearFromLeft} 1s;
  padding-bottom: 50px;

  ${({ summary }) =>
    summary &&
    css`
      max-width: 880px;
    `}
`;

export const NavegationAndInfosContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 130px;

  @media (max-width: 650px) {
    display: block;
  }
`;

export const BackButton = styled.div`
  font-size: 16px;
  color: rgba(98, 116, 142, 1);
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;

  &:hover {
    color: #000;
  }
`;
export const BackIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackSpan = styled.span`
  font-weight: bold;
  color: black;
  margin-left: 10px;
`;

export const EventBadge = styled.div`
  background-color: rgba(240, 250, 255, 1);
  color: rgba(6, 113, 158, 1);
  border-radius: 8px;
  font-size: 14px;
  height: 27px;
  width: 99px;
  font-weight: bold;
  font-family: "Inter";
  justify-content: center;
  align-items: center;
  display: flex;
`;
export const ClienteBadge = styled.div`
  background-color: rgba(226, 226, 247, 0.2);
  min-width: 224px;
  height: 33px;
  font-size: 14px;
  font-family: "Inter";
  font-weight: bold;
  color: rgba(49, 65, 88, 1);
  justify-content: center;
  align-items: center;
  display: flex;
  @media (max-width: 650px) {
    margin-top: 10px;
    background-color: transparent;
    max-width: 100%;
  }
`;
export const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  // margin-bottom: 10px;
  color: rgba(0, 34, 68, 1);
  font-family: "Inter";

  @media (max-width: 1200px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const SubTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #314158;
  line-height: 100%;
  font-family: "Inter";

  @media (max-width: 1200px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

export const SearchContainerFormItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
`;

export const IconWrapperSearchFormItem = styled.div`
  position: absolute;
  top: 34%;
  left: 10px;
  transform: translateY(-50%);
  z-index: 100;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px 10px 10px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
`;

export const StyledSpan = styled.span`
  color: rgba(49, 65, 88, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: "Inter";

  ${({ title }) =>
    title &&
    css`
      font-weight: 500;
      line-height: 150%;
      letter-spacing: 0px;
    `}
`;
